import React from 'react';

import { Table } from 'react-bootstrap';
import moment from 'moment';

import {
  OrderPaymentDetails,
  OrderPaymentDetailsObject,
} from '../../../types/Order';
import { convertNumberToUSD } from '../../../infrastructure/utils/common';

type Props = {
  paymentDetails: OrderPaymentDetails[];
  tz: string;
};

const normalizeType = (type: string) => {
  switch (type) {
    case OrderPaymentDetailsObject.charge:
      return 'Charge';
    case OrderPaymentDetailsObject.refund:
      return 'Refund';
    case OrderPaymentDetailsObject.paymentIntent:
      return 'Payment Intent';
    case OrderPaymentDetailsObject.transfer:
      return 'Transfer';
    case OrderPaymentDetailsObject.transferReversal:
      return 'Transfer Reversal';
    default:
      return '';
  }
};

const formatDate = (timestamp, tz: string | null = null) =>
  tz
    ? moment(timestamp).tz(tz).format('lll z')
    : moment(timestamp).format('lll z');

const PaymentDetails = ({ paymentDetails, tz }: Props) => {
  if (paymentDetails.length === 0) {
    return <div>There are no payment details associated with this order.</div>;
  }

  return (
    <Table responsive>
      <thead>
        <tr>
          <th>Type</th>
          <th>Amount</th>
          <th className='text-right'>Date</th>
        </tr>
      </thead>
      <tbody>
        {paymentDetails.map(details => (
          <tr key={details.id}>
            <td>{normalizeType(details.object)}</td>
            <td>{convertNumberToUSD(details.amount / 100)}</td>
            <td className='text-right'>
              {formatDate(details.created * 1000, tz)}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default React.memo(PaymentDetails);
